export default {
  new: 'Neu',
  game_developer: 'Spieleentwickler'
};



/** WEBPACK FOOTER **
 ** ./src/configs/localization/mapDE.js
 **/